import { useAppSelector } from "app/hooks";
import { selectThemeMode } from "common";
import { selectAccessToken } from "features/identity/identitySlice";
import { useEffect, useRef } from "react";
import AdminRouter from "routers/AdminRouter";
import PublicRouter from "routers/PublicRouter";

export default function App() {
  const access_token = useAppSelector(selectAccessToken);
  const themeMode = useAppSelector(selectThemeMode);
  const refMode = useRef(themeMode);

  useEffect(() => {
    if (themeMode !== refMode.current) {
      if (window?.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ themeMode }));
      }
      refMode.current = themeMode;
    }
  }, [themeMode]);
  return <>{!access_token ? <PublicRouter /> : <AdminRouter />}</>;
}
